import { useCallback } from "react";

import { useObjectMemo } from "../../../hooks";
import { useRequestWithFeedback } from "../../../composites";
import { useAppDispatch } from "../utils";

import { API } from "./api";
import { withFileImportStates } from "./helpers";
import { actions } from "./slice";

import type { FileImportItem } from "./types";

export const useFetchPaginatedFileImports = () => {
  const { send, loading, status } = useRequestWithFeedback<{
    results: FileImportItem[];
    page: { totalElements: number };
  }>();

  const dispatch = useAppDispatch();

  const fetchPage = useCallback(
    (
      pageNumber: number,
      offsetIndex: number,
      pageSize: number,
      queryString?: string,
      // unused: file imports have no ordering, but hooks.ts passes
      // disableCaching as the 6th argument
      _ordering?: string,
      disableCaching?: boolean,
    ) => {
      return send({
        action: API.fetchFileImports(
          offsetIndex,
          pageSize,
          withFileImportStates(queryString),
          disableCaching,
        ),
        onData: ({ results, page: { totalElements } }) => {
          dispatch(
            actions.upsertPage({
              pageNumber,
              results,
              total: totalElements,
            }),
          );
        },
      });
    },
    [send, dispatch],
  );

  return useObjectMemo({
    error: status === "error",
    send: fetchPage,
    loading,
  });
};
